<app-nav-header></app-nav-header>
<div class="wrapper">
    <div class="main">
        <div id="productsPage">
            <div
                class="bannerArea"
                id="bannerArea">
                <div class="bannerBox">
                    <div class="wordBox">
                        <h1>{{ 'products.title' | translate }}</h1>
                        <h2>{{ 'products.subtitle' | translate }}</h2>
                    </div>
                </div>
            </div>

            <div class="coreServiceArea">
                <div class="coreServiceBox">
                    <div class="wheelBox">
                        <div
                            class="hexagon"
                            [ngClass]="{
								rotate60: activeIdx === 1,
								rotate120: activeIdx === 2,
								rotate180: activeIdx === 3,
								rotate240: activeIdx === 4,
								rotate300: activeIdx === 5,
							}">
                            <div
                                class="point middle-right"
                                (click)="this.activeIdx = 0"
                                [ngClass]="{
                                    'main-character': activeIdx === 0
                                }">
                                <div class="core">
                                    <img
                                        src="/assets/images/products/core-product-big-data.webp"
                                        alt="大數據" />
                                    <h3>
                                        {{
                                            'products.core.bigData' | translate
                                        }}
                                    </h3>
                                </div>
                            </div>

                            <div
                                class="point top-right"
                                (click)="this.activeIdx = 1"
                                [ngClass]="{
                                    'main-character': activeIdx === 1
                                }">
                                <div class="core">
                                    <img
                                        src="/assets/images/products/core-product-iot.webp"
                                        alt="物聯網" />
                                    <h3>
                                        {{ 'products.core.iot' | translate }}
                                    </h3>
                                </div>
                            </div>

                            <div
                                class="point top-left"
                                (click)="this.activeIdx = 2"
                                [ngClass]="{
                                    'main-character': activeIdx === 2
                                }">
                                <div class="core">
                                    <img
                                        src="/assets/images/products/core-product-ai.webp"
                                        alt="人工智慧" />
                                    <h3>
                                        {{ 'products.core.ai' | translate }}
                                    </h3>
                                </div>
                            </div>

                            <div
                                class="point middle-left"
                                (click)="this.activeIdx = 3"
                                [ngClass]="{
                                    'main-character': activeIdx === 3
                                }">
                                <div class="core">
                                    <img
                                        src="/assets/images/products/core-product-info-security.webp"
                                        alt="資訊安全" />
                                    <h3>
                                        {{
                                            'products.core.infoSecurity'
                                                | translate
                                        }}
                                    </h3>
                                </div>
                            </div>

                            <div
                                class="point bottom-left"
                                (click)="this.activeIdx = 4"
                                [ngClass]="{
                                    'main-character': activeIdx === 4
                                }">
                                <div class="core">
                                    <img
                                        src="/assets/images/products/core-product-data-consolidation.webp"
                                        alt="數據整合" />
                                    <h3>
                                        {{
                                            'products.core.dataIntegration'
                                                | translate
                                        }}
                                    </h3>
                                </div>
                            </div>

                            <div
                                class="point bottom-right"
                                (click)="this.activeIdx = 5"
                                [ngClass]="{
                                    'main-character': activeIdx === 5
                                }">
                                <div class="core">
                                    <img
                                        src="/assets/images/products/core-product-tech-support.webp"
                                        alt="技術支援" />
                                    <h3>
                                        {{
                                            'products.core.technicalSupport'
                                                | translate
                                        }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="narrativeBox">
                        <span>{{ 'products.title' | translate }}</span>
                        <h2>{{ 'products.content' | translate }}</h2>
                        <p-accordion [(activeIndex)]="activeIdx">
                            <p-accordionTab
                                [header]="
                                    'products.tab.bigDataAnalysis' | translate
                                ">
                                <div class="detail">
                                    <p>
                                        {{
                                            'products.detail.bigDataAnalysis'
                                                | translate
                                        }}
                                    </p>
                                </div>
                                <!-- <ng-container
                                    *ngTemplateOutlet="
                                        moreBtn;
                                        context: {
                                            parameter: { keyword: '大數據' }
                                        }
                                    "></ng-container> -->
                            </p-accordionTab>
                            <p-accordionTab
                                [header]="
                                    'products.tab.internetOfThings' | translate
                                ">
                                <div class="detail">
                                    <p>
                                        {{
                                            'products.detail.internetOfThings'
                                                | translate
                                        }}
                                    </p>
                                </div>
                                <!-- <ng-container
                                    *ngTemplateOutlet="
                                        moreBtn;
                                        context: {
                                            parameter: { keyword: '物聯網' }
                                        }
                                    "></ng-container> -->
                            </p-accordionTab>
                            <p-accordionTab
                                [header]="
                                    'products.tab.artificialIntelligence'
                                        | translate
                                ">
                                <div class="detail">
                                    <p>
                                        {{
                                            'products.detail.artificialIntelligence'
                                                | translate
                                        }}
                                    </p>
                                </div>
                                <!-- <ng-container
                                    *ngTemplateOutlet="
                                        moreBtn;
                                        context: {
                                            parameter: { keyword: '人工智慧' }
                                        }
                                    "></ng-container> -->
                            </p-accordionTab>
                            <p-accordionTab
                                [header]="
                                    'products.tab.informationSecurity'
                                        | translate
                                ">
                                <div class="detail">
                                    <p>
                                        {{
                                            'products.detail.informationSecurity'
                                                | translate
                                        }}
                                    </p>
                                </div>
                                <!-- <ng-container
                                    *ngTemplateOutlet="
                                        moreBtn;
                                        context: {
                                            parameter: { keyword: '資訊安全' }
                                        }
                                    "></ng-container> -->
                            </p-accordionTab>
                            <p-accordionTab
                                [header]="
                                    'products.tab.dataIntegration' | translate
                                ">
                                <div class="detail">
                                    <p>
                                        {{
                                            'products.detail.dataIntegration'
                                                | translate
                                        }}
                                    </p>
                                </div>
                                <!-- <ng-container
                                    *ngTemplateOutlet="
                                        moreBtn;
                                        context: {
                                            parameter: { keyword: '數據整合' }
                                        }
                                    "></ng-container> -->
                            </p-accordionTab>
                            <p-accordionTab
                                [header]="
                                    'products.tab.technicalSupport' | translate
                                ">
                                <div class="detail">
                                    <p>
                                        {{
                                            'products.detail.technicalSupport'
                                                | translate
                                        }}
                                    </p>
                                </div>
                                <!-- <ng-container
                                    *ngTemplateOutlet="
                                        moreBtn;
                                        context: {
                                            parameter: { keyword: '技術支援' }
                                        }
                                    "></ng-container> -->
                            </p-accordionTab>
                        </p-accordion>
                    </div>
                </div>

                <div class="coreServiceBoxMd">
                    <div class="titleBox">
                        <span>{{ 'products.title' | translate }}</span>
                        <h2>
                            {{ 'products.content' | translate }}
                        </h2>
                    </div>

                    <div class="collection">
                        <div class="service">
                            <img
                                src="/assets/images/products/core-product-big-data.webp"
                                alt="大數據" />
                            <h3>{{ 'products.core.bigData' | translate }}</h3>
                            <p>
                                {{
                                    'products.detail.bigDataAnalysis'
                                        | translate
                                }}
                            </p>
                            <!-- <ng-container
                                *ngTemplateOutlet="
                                    moreBtn;
                                    context: {
                                        parameter: { keyword: '大數據' }
                                    }
                                "></ng-container> -->
                        </div>
                        <div class="service">
                            <img
                                src="/assets/images/products/core-product-iot.webp"
                                alt="物聯網" />
                            <h3>{{ 'products.core.iot' | translate }}</h3>
                            <p>
                                {{
                                    'products.detail.internetOfThings'
                                        | translate
                                }}
                            </p>
                            <!-- <ng-container
                                *ngTemplateOutlet="
                                    moreBtn;
                                    context: {
                                        parameter: { keyword: '物聯網' }
                                    }
                                "></ng-container> -->
                        </div>
                        <div class="service">
                            <img
                                src="/assets/images/products/core-product-ai.webp"
                                alt="人工智慧" />
                            <h3>{{ 'products.core.ai' | translate }}</h3>
                            <p>
                                {{
                                    'products.detail.artificialIntelligence'
                                        | translate
                                }}
                            </p>
                            <!-- <ng-container
                                *ngTemplateOutlet="
                                    moreBtn;
                                    context: {
                                        parameter: { keyword: '人工智慧' }
                                    }
                                "></ng-container> -->
                        </div>
                        <div class="service">
                            <img
                                src="/assets/images/products/core-product-info-security.webp"
                                alt="資訊安全" />
                            <h3>
                                {{ 'products.core.infoSecurity' | translate }}
                            </h3>
                            <p>
                                {{
                                    'products.detail.informationSecurity'
                                        | translate
                                }}
                            </p>
                            <!-- <ng-container
                                *ngTemplateOutlet="
                                    moreBtn;
                                    context: {
                                        parameter: { keyword: '資訊安全' }
                                    }
                                "></ng-container> -->
                        </div>
                        <div class="service">
                            <img
                                src="/assets/images/products/core-product-data-consolidation.webp"
                                alt="數據整合" />
                            <h3>
                                {{
                                    'products.core.dataIntegration' | translate
                                }}
                            </h3>
                            <p>
                                {{
                                    'products.detail.dataIntegration'
                                        | translate
                                }}
                            </p>
                            <!-- <ng-container
                                *ngTemplateOutlet="
                                    moreBtn;
                                    context: {
                                        parameter: { keyword: '數據整合' }
                                    }
                                "></ng-container> -->
                        </div>
                        <div class="service">
                            <img
                                src="/assets/images/products/core-product-tech-support.webp"
                                alt="技術支援" />
                            <h3>
                                {{
                                    'products.core.technicalSupport' | translate
                                }}
                            </h3>
                            <p>
                                {{
                                    'products.detail.technicalSupport'
                                        | translate
                                }}
                            </p>
                            <!-- <ng-container
                                *ngTemplateOutlet="
                                    moreBtn;
                                    context: {
                                        parameter: { keyword: '技術支援' }
                                    }
                                "></ng-container> -->
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="exploreArea"
                id="exploreArea">
                <div class="exploreBox">
                    <div class="searchBox">
                        <h2>{{ 'products.search.title' | translate }}</h2>
                        <div class="searchInputBox">
                            <span class="p-input-icon-left">
                                <i
                                    class="left-icon-cus pi pi-search"
                                    (click)="
                                        getProductByKeyword(kw.value, $event)
                                    "></i>
                                <input
                                    #kw
                                    class="search-input-cus"
                                    type="text"
                                    pInputText
                                    [(ngModel)]="keywordRaw"
                                    [placeholder]="
                                        'products.search.placeholder'
                                            | translate
                                    "
                                    (keypress)="
                                        $event.key === 'Enter'
                                            ? getProductByKeyword(
                                                  kw.value,
                                                  $event
                                              )
                                            : null
                                    " />
                                <i
                                    class="right-icon-cus pi pi-times-circle"
                                    (click)="keywordRaw = ''"></i>
                            </span>
                            <button
                                type="button"
                                class="p-button p-button-outlined"
                                (click)="getProductByKeyword(kw.value, $event)">
                                {{ 'products.button.submit' | translate }}
                            </button>
                        </div>
                        <div class="tagBox">
                            <ng-container *ngFor="let tagKey of recommendTags">
                                <span
                                    (click)="addTagToKeyword(tagKey)">
                                    {{
                                        'products.search.recommendTags.' +
                                            tagKey | translate
                                    }}
                                </span>
                            </ng-container>
                        </div>
                    </div>
                    <div class="resultsBox">
                        <ng-container
                            *ngIf="productsByKeyword.length; else noProducts">
                            <div class="cardContainer">
                                <ng-container
                                    *ngFor="
                                        let result of productsByPage;
                                        let index = index
                                    ">
                                    <div
                                        class="infoCard"
                                        (click)="goToProduct(result?.NameEN)">
                                        <div class="imgBox">
                                            <img
                                                [src]="imgMap[index % 5]"
                                                alt="" />
                                        </div>
                                        <div class="vital">
                                            <h3>
                                                {{
                                                    'products.products.' +
                                                        getProductKeyFromNameEN(
                                                            result?.NameEN
                                                        ) +
                                                        '.name' | translate
                                                }}
                                            </h3>
                                            <div class="tagBox">
                                                <ng-container
                                                    *ngFor="
                                                        let tag of 'products.products.' +
                                                            getProductKeyFromNameEN(
                                                                result?.NameEN
                                                            ) +
                                                            '.tags' | translate
                                                    ">
                                                    <span>{{ tag }}</span>
                                                </ng-container>
                                            </div>
                                            <p>
                                                {{
                                                    'products.products.' +
                                                        getProductKeyFromNameEN(
                                                            result?.NameEN
                                                        ) +
                                                        '.desc' | translate
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="paginationBox">
                                <p-paginator
                                    (onPageChange)="getDataByPage($event)"
                                    [first]="1"
                                    [rows]="rowsPerPage"
                                    [totalRecords]="productsByKeyword.length"
                                    [showFirstLastIcon]="false"></p-paginator>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <app-partnership></app-partnership>
        </div>
    </div>
</div>
<app-footer></app-footer>

<ng-template
    #moreBtn
    let-parameter="parameter">
    <button
        class="more-btn"
        (click)="
            kw.value = parameter.keyword; getProductByKeyword(kw.value, $event)
        ">
        <span>{{ 'products.button.more' | translate }}</span>
        <i
            class="fa fa-arrow-right"
            aria-hidden="true"></i>
    </button>
</ng-template>

<ng-template #noProducts>
    <div class="noResultBox">
        <p>{{ 'products.noResult' | translate }}</p>
    </div>
</ng-template>
